<template>
  <div>
    <!-- 日付選択 -->
    <MFITTBookingDisabledSelectDate
      v-if="isDisabledSelectDate"
      :date="selectedDate"
    />
    <section v-else-if="isChangeableBoardingDate">
      <div class="title-block clearfix">
        乗車日
        <span v-if="!isUseCoupon" class="float-text"
          >当日〜1ヶ月先まで選択できます。</span
        >
      </div>
      <div class="column">
        <div class="field">
          <input
            ref="datePicker"
            v-model="selectedDate"
            :min="selectableStartDate"
            :max="selectableLimitDate"
            type="date"
            name="date"
            required="required"
          />
        </div>
      </div>
      <div v-if="!isValidDate" class="error-block">
        有効な日付を選択してください。
      </div>
    </section>

    <!-- 時刻選択 -->
    <section>
      <div class="title-block">時間</div>
      <div class="column time">
        <div class="row">
          <div class="field">
            <div class="select-wrap">
              <input v-model="selectedTime" type="time" class="time" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="radio-wrap">
            <div class="radio">
              <input
                id="radio3-1"
                v-model="dateRadio"
                name="radio3"
                type="radio"
                :value="3"
              />
              <label for="radio3-1" class="radio-label">出発</label>
            </div>
            <div class="radio">
              <input
                id="radio3-2"
                v-model="dateRadio"
                name="radio3"
                type="radio"
                :value="4"
              />
              <label for="radio3-2" class="radio-label">到着</label>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import { useVModel } from "vue-composable";

import mfittService from "@/services/MFITT";
import moment from "@/services/moment";

export default {
  name: "MFITTBookingSelectDate",
  props: {
    dateRadio: {
      type: Number,
      required: true,
    },
    selectedDate: {
      type: String,
      required: true,
    },
    selectedTime: {
      type: String,
      required: true,
    },
    isValidDate: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();

    const dateRadio = useVModel(props, "dateRadio");
    const selectedDate = useVModel(props, "selectedDate");
    const selectedTime = useVModel(props, "selectedTime");
    const selectableStartDate = ref(null);
    const selectableLimitDate = ref(null);
    const selectedCoupon = store.getters["MFITT/selectedCoupon"];
    const isDisabledSelectDate = ref(false);
    const isUseCoupon = selectedCoupon != null;

    const isChangeableBoardingDate = computed(
      () =>
        store.getters["MFITT/myLimitedExpressTicket"] == null ||
        store.getters["MFITT/myLimitedExpressTicket"]
          .changeable_boarding_date == null ||
        store.getters["MFITT/myLimitedExpressTicket"]
          .changeable_boarding_date == true
    );

    const disabledSelectDateIfSelectableOnlyOneDay = () => {
      // 選択可能範囲が1日のみの場合は操作不可にする
      // 初期値は今日なので、選択可能範囲(日付)が今日以外の場合も考慮し、開始日を選択した状態にする
      if (selectableStartDate.value == selectableLimitDate.value) {
        selectedDate.value = selectableStartDate.value;
        isDisabledSelectDate.value = true;
      }
    };

    onMounted(() => {
      if (selectedCoupon) {
        selectableStartDate.value = mfittService.getBoardingStartDate(
          selectedCoupon.boarding_start_date
        );
        selectableLimitDate.value = selectedCoupon.boarding_end_date;
      } else {
        selectableStartDate.value = moment(new Date()).format("YYYY-MM-DD");
        selectableLimitDate.value = mfittService.getAfterOneMonthDate();
      }

      if (selectedDate.value < selectableStartDate.value) {
        selectedDate.value = selectableStartDate.value;
      }
      disabledSelectDateIfSelectableOnlyOneDay();
    });

    return {
      isDisabledSelectDate,
      isUseCoupon,
      dateRadio,
      selectedDate,
      selectedTime,
      selectableStartDate,
      selectableLimitDate,
      isChangeableBoardingDate,
    };
  },
};
</script>
<style lang="scss" scoped>
.title-block {
  margin: 20px 6px 8px;
  font-size: 13px;
  text-align: left;
  line-height: 17px;
  font-weight: bold;
}

.float-text {
  float: right;
  font-weight: normal;
}

.column .error-block {
  margin: 10px 0;
  font-size: 13px;
  font-weight: bold;
  text-align: right;
  line-height: 17px;
  color: #ff3333;
}

.column {
  margin-bottom: 16px;
  margin-top: 0;
}

.field {
  position: relative;
  margin: 0 0 0 0;
}

.field label {
  position: absolute;
  width: 150px;
  z-index: 100;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  font-size: 13px;
  color: #888888;
}

.section {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}

.section .row:first-child {
  width: 40px;
  margin-right: 10px;
}

.section .row:last-of-type {
  width: calc(100% - 50px);
}

input[type="date"]::-webkit-calendar-picker-indicator {
  background: none;
  /*dateでのカレンダーアイコンを非表示にする*/
}

.field input[type="text"],
.field input[type="date"] {
  -webkit-appearance: none;
  /*デフォルトスタイルを無効にする*/
  -moz-appearance: none;
  appearance: none;
  width: calc(100% - 22px);
  height: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px 10px 12px 10px;
  font-size: 16px;
  font-weight: bold;
  background: white;
  color: #000000;
}

.field input[type="date"] {
  background-image: url("~@/assets/img/icon/svg/icon-calendar.svg");
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) center;
}

/*時間のレイアウト*/
.field input[type="time"] {
  -webkit-appearance: none;
  width: 90%;
  height: 20px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #ffffff;
  outline: none;
  padding: 12px 10px 12px 10px;
  font-size: 14px;
  line-height: 14px;
  font-weight: bold;
  color: #000000;
}

input[type="time"]::-webkit-calendar-picker-indicator {
  background: none;
  /*timeでの時計アイコンを非表示にする*/
}

.time {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}

.time .row:first-child {
  width: 30%;
  margin-right: 10px;
}

.time .row:last-of-type {
  width: 70%;
  margin-top: 4px;
}

/* セレクトボックス */
select {
  -webkit-appearance: none;
  width: 100%;
  height: 42px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #ffffff;
  outline: none;
  padding: 12px 10px 12px 150px;
  font-size: 14px;
  line-height: 14px;
  font-weight: bold;
  color: #000000;
}

select:focus {
  border-color: #e0e0e0;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 6px;
}

.select-wrap::after {
  content: "";
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #b4b3b3;
  border-right: solid 2px #b4b3b3;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  right: 3vw;
  margin-top: -4px;
}

/* ラジオボタン */
.radio-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 0 5px;
}

.radio-wrap {
  justify-content: space-between;
}

.radio {
  margin: 0.5rem !important;
}

.radio input[type="radio"] {
  position: absolute;
  opacity: 0;
}

.radio input[type="radio"] + .radio-label:before {
  content: "";
  background: #f4f4f4;
  border-radius: 100%;
  border: 1px solid #b4b4b4;
  display: inline-block;
  width: 1.4em;
  height: 1.4em;
  position: relative;
  top: -0.2em;
  margin-right: 1em;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
  transition: all 250ms ease;
}

.radio input[type="radio"]:checked + .radio-label:before {
  background-color: #ff7600;
  box-shadow: inset 0 0 0 4px #f4f4f4;
}

.radio input[type="radio"]:focus + .radio-label:before {
  outline: none;
  border-color: #ff7600;
}

.radio input[type="radio"]:disabled + .radio-label:before {
  box-shadow: inset 0 0 0 4px #f4f4f4;
  border-color: #b4b4b4;
  background: #b4b4b4;
}

.radio input[type="radio"] + .radio-label:empty:before {
  margin-right: 0;
}
</style>
